export const pageTitle = (title) => {
  return ( document.title = title + " - CodeWus | Software Development");
}